export default {
  contact: (param) => `profile/contacts?${buildQuery(param)}`,
  editContact: "profile/contacts/update",
  postContact: "profile/contacts",
  deleteContact: (param) => `profile/contacts/destroy?${buildQuery(param)}`,
};

function buildQuery(param) {
  const query = new URLSearchParams(param);
  return query.toString();
}
